// 실시간 데이터 datagrid
export const UI_1_2_tableRow1 = [
  [
    {
      cellName: "날짜",
      id: "date",
      row: 1,
      col: 1,
    },
    {
      cellName: "시간",
      id: "time",
      row: 1,
      col: 1,
    },
    {
      cellName: "에너지종류",
      id: "energy",
      row: 1,
      col: 1,
    },
    {
      cellName: "사용/공급",
      id: "method",
      row: 1,
      col: 1,
    },
    {
      cellName: "단위",
      id: "unit",
      row: 1,
      col: 1,
    },
    {
      cellName: "산업단지명",
      id: "complexName",
      row: 1,
      col: 1,
    },
    {
      cellName: "실제공급량",
      id: "actualSupply",
      row: 1,
      col: 1,
    },
    {
      cellName: "예측공급량",
      id: "predictedSupply",
      row: 1,
      col: 1,
    },
    {
      cellName: "오차율",
      id: "errorRate",
      row: 1,
      col: 1,
    },
  ]
];

// 일일 데이터 datagrid
export const UI_1_2_tableRow2 = [
  [
    {
      cellName: "날짜",
      id: "date",
      row: 1,
      col: 1,
    },
    {
      cellName: "에너지종류",
      id: "energy",
      row: 1,
      col: 1,
    },
    {
      cellName: "사용/공급",
      id: "method",
      row: 1,
      col: 1,
    },
    {
      cellName: "단위",
      id: "unit",
      row: 1,
      col: 1,
    },
    {
      cellName: "산업단지명",
      id: "complexName",
      row: 1,
      col: 1,
    },
    {
      cellName: "실제공급량",
      id: "actualSupply",
      row: 1,
      col: 1,
    },
    {
      cellName: "예측공급량",
      id: "predictedSupply",
      row: 1,
      col: 1,
    },
    {
      cellName: "오차율",
      id: "errorRate",
      row: 1,
      col: 1,
    },
    {
      cellName: "예측정확도(%)",
      id: "predictionAccuracy",
      row: 1,
      col: 1,
    },
  ]
];


// 데이터가 없어 임시로 보여주기 위한 하드코딩
export const UI_1_2_gridData1 = [
  {
    year: "2024.01.14",
    time: "23:45 ~ 00:00",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "0",
    predictedSupply: "0.2075",
    errorRate: "-"
  },
  {
    year: "2024.01.14",
    time: "14:45 ~ 15:00",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "90",
    predictedSupply: "91.8512",
    errorRate: "2.02"
  },
  {
    year: "2024.01.14",
    time: "14:30 ~ 14:45",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "80",
    predictedSupply: "81.7741",
    errorRate: "2.17"
  },
];


// 데이터가 없어 임시로 보여주기 위한 하드코딩
export const UI_1_2_gridData2 = [
  {
    year: "2024.01.14",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "304",
    predictedSupply: "320",
    errorRate: "5.03%",
    predictionAccuracy: "94.97%"
  },
  {
    year: "2024.01.13",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "545",
    predictedSupply: "570",
    errorRate: "4.32%",
    predictionAccuracy: "95.68%"
  },
  {
    year: "2024.01.12",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "1257",
    predictedSupply: "1250",
    errorRate: "0.55%",
    predictionAccuracy: "100.55%"
  },
  {
    year: "2024.01.14",
    energy: "압축공기",
    method: "공급",
    unit: "N㎥",
    complexName: "시화도금단지",
    companyName: "조합공용",
    plantName: "조합공용",
    actualSupply: "1432",
    predictedSupply: "1410",
    errorRate: "1.55%",
    predictionAccuracy: "101.55%"
  },
];